import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a28e530"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login-view flex column align-center justify-center" }
const _hoisted_2 = { class: "form flex column gap-20 font-size-14 card-style p-20" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title font-size-20" }, "BAT Framework", -1))
const _hoisted_4 = { class: "inputs flex column gap-10 align-start" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "subtitle" }, "帳號", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "subtitle" }, "密碼", -1))
const _hoisted_7 = { class: "ops" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(_component_el_input, {
          modelValue: _ctx.account,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.account) = $event))
        }, null, 8, ["modelValue"]),
        _hoisted_6,
        _createVNode(_component_el_input, {
          modelValue: _ctx.password,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
          type: "password"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_el_button, {
          onClick: _ctx.login,
          type: "primary"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Login")
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ])
  ]))
}